import merchant_category_codes_json from './mcc.json';

export const getMerchantCategoryCodes = () =>
  new Map(merchant_category_codes_json.map((entry) => [entry.mcc, entry]));
